import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { colors } from '../../../../../colorVars';

function BidAskVerticalTicks({ size, width, scaleY, numberOfTicks, tickSize, weight }) {
  const ticks = useMemo(() => {
    if (scaleY !== null) {
      return scaleY.ticks(numberOfTicks).map((value) => ({
        value,
        offset: scaleY(value),
      }));
    } else {
      return null;
    }
  }, [scaleY, size, numberOfTicks]);

  return (
    <g stroke={colors.white} strokeWidth={weight}>
      <line x1={width} y1={0} x2={width} y2={size} />
      {ticks !== null &&
        ticks.map(({ value, offset }) => (
          <line
            x1={width}
            y1={offset}
            x2={width - tickSize}
            y2={offset}
            key={value}
          />
        ))}
    </g>
  );
}

BidAskVerticalTicks.propTypes = {
  numberOfTicks: PropTypes.number,
  scaleY: PropTypes.func,
  size: PropTypes.number,
  bottomPadding: PropTypes.number,
  tickSize: PropTypes.number,
  weight: PropTypes.number,
  width: PropTypes.number,
};

export default BidAskVerticalTicks;
